export default __webpack_public_path__ + "static/media/a97a5e15f5d194475a6e9f2a828f31dd.webp";